import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FeeService } from '../service/fee.service';

export interface FeeIndustryDeleteDialogData {
  industryId: number;
  companyName: string;
}

@Component({
  selector: 'app-fee-industry-delete-dialog',
  templateUrl: './fee-industry-delete-dialog.component.html',
  styleUrls: ['./fee-industry-delete-dialog.component.scss']
})
export class FeeIndustryDeleteDialogComponent implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  deleting = false;
  hasDeleteError = false;

  constructor(
    private readonly dialogRef: MatDialogRef<FeeIndustryDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) readonly data: FeeIndustryDeleteDialogData,
    private readonly feeService: FeeService
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirmDelete(): void {
    if (this.deleting) return;
    this.deleting = true;
    this.hasDeleteError = false;

    this.feeService.deleteUserIndustry(this.data.industryId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => this.dialogRef.close(true),
        error: () => {
          this.deleting = false;
          this.hasDeleteError = true;
        }
      });
  }
}
